<template>
  <ul class="br-notes-skel">
    <li v-for="n in count" :key="n" class="br-notes-skel__row">
      <i /><i /><i /><i />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BrAdminNotesSkeleton',
  props: {
    count: { type: Number, default: 1 },
  },
};
</script>

<style scoped lang="scss">
.br-notes-skel {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 16px;
}

.br-notes-skel__row {
  display: grid;
  grid: auto auto / 28px 150px 77px;
  gap: 8px;
  pointer-events: none;

  i {
    height: 18px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.06);
    animation: br-notes-skel-pulse 1.2s ease-in-out infinite;

    &:first-child {
      height: 28px;
      border-radius: 50%;
      grid-row: 1 / 3;
    }

    &:last-child {
      grid-column: 2 / 4;
      width: min(315px, 100%);
    }
  }
}

@keyframes br-notes-skel-pulse {
  50% { opacity: 0.55; }
}
</style>
